import type { IconProps } from './IconProps';

export const ToastCheckmarkIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7345 3.29848C15.1219 3.69207 15.1169 4.32522 14.7234 4.71265L6.59637 12.7127C6.20716 13.0958 5.58254 13.0958 5.19333 12.7127L1.89174 9.46265C1.49816 9.07522 1.49317 8.44207 1.88061 8.04848C2.26805 7.6549 2.90119 7.64991 3.29478 8.03735L5.89485 10.5968L13.3203 3.28735C13.7139 2.89991 14.347 2.9049 14.7345 3.29848Z"
      fill="white"
    />
  </svg>
);
